
const SettingSidebar = ({ menus, menuActive, setMenuActive }) => {
	const handleMenu = (menu, index) => {
		const newMenu = { ...menu, value: index };
		sessionStorage.setItem('settingMenuActive', JSON.stringify(newMenu))
    setMenuActive(newMenu);
  }
	
  return (
   <div className={`side-bar-container w-56`}>
			<div className="menus-container mt-8">
				{menus?.map((menu, index) => {
					const isActive = index === menuActive?.value;
					return (
						<div 
							className={`menu-line ${isActive ? 'active' : ''}`} key={index}
							onClick={() => handleMenu(menu, index)} 
						>
							{isActive && <div className="menu-active-border"></div>}
							{menu.icon && <i className={`${menu.icon} text-xl`}></i>}
							<p className={`${(isActive) ? 'font-bold' : 'font-regular'} text-md`}>{menu.label}</p>
						</div>
					)
				})}
			</div>
   </div>     
  )
}

export default SettingSidebar